import { render, staticRenderFns } from "./Week.vue?vue&type=template&id=1f4b3b12&scoped=true&"
import script from "./Week.vue?vue&type=script&lang=js&"
export * from "./Week.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4b3b12",
  null
  
)

export default component.exports